import { IProjectLanguageData } from "src/model/model";
import { ContentFieldSchemaEntry } from "./FieldDescriptor";

interface PldWithTimestamp extends IProjectLanguageData {
  id?: number;
  updatedAt?: string;
  stale_field_keys?: unknown;
}

interface ComputeStaleFieldsParams {
  plds: PldWithTimestamp[] | undefined;
  sourceLanguageId: number;
  schema: ContentFieldSchemaEntry | null;
}

export const computeStaleFields = ({
  plds,
  sourceLanguageId,
  schema,
}: ComputeStaleFieldsParams): Record<number, Set<string>> => {
  const out: Record<number, Set<string>> = {};
  if (!plds || plds.length === 0) return out;

  const pldKeyToContentKey = new Map<string, string>(
    (schema?.fields ?? []).filter((f) => !!f.pldKey).map((f) => [f.pldKey as string, f.key]),
  );

  const sourcePld = plds.find((p) => Number(p.language) === Number(sourceLanguageId));
  const sourceUpdatedAt = new Date(sourcePld?.updatedAt ?? 0).getTime();

  for (const pld of plds) {
    const languageId = Number(pld.language);
    if (languageId === Number(sourceLanguageId)) {
      out[languageId] = new Set();
      continue;
    }
    const persisted = Array.isArray(pld.stale_field_keys)
      ? (pld.stale_field_keys as string[])
      : null;
    if (persisted !== null) {
      out[languageId] = new Set(persisted.map((k) => pldKeyToContentKey.get(k) ?? k));
      continue;
    }
    // Fallback: pre-Phase-5 rows without the column populated — use the
    // updatedAt MVP from Phase 3.
    const targetUpdatedAt = new Date(pld.updatedAt ?? 0).getTime();
    const stale = new Set<string>();
    if (sourceUpdatedAt > targetUpdatedAt + 1000) {
      for (const f of schema?.fields ?? []) {
        if (f.isTranslatable) stale.add(f.key);
      }
    }
    out[languageId] = stale;
  }
  return out;
};
